document.addEventListener('DOMContentLoaded', function() {
  var sliders = document.querySelectorAll('.slideshow__owl-carousel');
  sliders.forEach(function(slider) {
    var itemsDesktop = parseInt(slider.getAttribute('data-items-desktop'), 10) || 1;
    var marginDesktop = parseInt(slider.getAttribute('data-margin-desktop'), 10) || 10;
    var itemsTablet = parseInt(slider.getAttribute('data-items-tablet'), 10) || 1;
    var marginTablet = parseInt(slider.getAttribute('data-margin-tablet'), 10) || 10;
    var itemsMobile = parseInt(slider.getAttribute('data-items-mobile'), 10) || 1;
    var marginMobile = parseInt(slider.getAttribute('data-margin-mobile'), 10) || 10;
    var arrowsEnabled = slider.getAttribute('data-arrows-enabled') === 'true';
    var autoplayEnabled = slider.getAttribute('data-autoplay-enabled') === 'true';
    var autoplayTimeout = parseInt(slider.getAttribute('data-autoplay-timeout'), 10) || 3000;
    var loopEnabled = slider.getAttribute('data-loop-enabled') === 'true';
    var dotsEnabled = slider.getAttribute('data-dots-enabled') === 'true';

    $(slider).owlCarousel({
      items: itemsDesktop,
      margin: marginDesktop,
      nav: arrowsEnabled,
      autoplay: autoplayEnabled,
      autoplayTimeout: autoplayTimeout,
      loop: loopEnabled,
      dots: dotsEnabled,
      responsive: {
        0: {
          items: itemsMobile,
          margin: marginMobile,
        },
        750: {
          items: itemsTablet,
          margin: marginTablet,
        },
        1200: {
          items: itemsDesktop,
          margin: marginDesktop,
        }
      }
    });
  });
});
